export const PAGE_LIMIT = 20;
